import { FC, HTMLAttributes, useState } from "react"

import { FieldError } from '../../../../../widgets'
import { ICheckBoxProps } from './ICheckBoxProps'
import clsx from 'clsx'
import { useCheckBoxValidationSchema } from './CheckBoxValidationSchema'

interface ICheckBoxFieldProps extends HTMLAttributes<HTMLInputElement>, ICheckBoxProps {
}

export const SimpleCheckBox: FC<ICheckBoxFieldProps> = (props) => {
    const { id, value: initValue, className, title, disabled } = props
    const schema = useCheckBoxValidationSchema(props)
    const [error, setError] = useState<string>();
    const [value, setValue] = useState<boolean>(initValue || false);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = event.target.checked;
        setValue(isChecked)

        schema?.validate(isChecked)
            .then(() => setError(undefined))
            .catch((error) => setError(error.message))
    }

    return <>
        <input
            type="checkbox"
            id={id}
            title={title}
            className={clsx(className, "form-check-input")}
            checked={value}
            disabled={disabled}
            onChange={handleChange}
        />
        {error && <FieldError show={true} message={error} />}
    </>
}
